<script lang="ts">
  import { ConfirmPopup, Form, InputDate, InputGroup } from '$shared/components';
  import type { CredReq } from '$shared/models/credReq/CredReq';
  import { DateValidator } from '$shared/helpers/validators/DateValidator';
  import { onMount } from 'svelte';

  interface Props {
    cvo: CredReq | undefined | null;
    loading?: boolean;
    error?: string;
    onevent?: (payload: any) => void;
  }

  let { cvo, loading = false, error = $bindable(''), onevent }: Props = $props();

  let appReceivedDate: string = $state('');
  let localError = $state('');

  onMount(() => {
    appReceivedDate = cvo?.applicationReceivedDate?.getDate() ?? '';
  });

  const onDateInputChange = (detail: string): void => {
    appReceivedDate = detail?.trim();
  };

  const handleEvent = (detail: any): void => {
    if (detail.type === 'ok') {
      if (!validate()) return;

      onevent?.({ type: detail.type, data: { appReceivedDate } });
      return;
    }
    onevent?.({ type: detail.type });
  };

  const validate = (): boolean => {
    try {
      const createdData = cvo?.createdAt?.getRawString() || '';
      DateValidator.maxDateValidator(appReceivedDate, createdData, 'Credentialing Request Created');
    } catch (err: unknown) {
      error = (err as Error).message;
      return false;
    }
    return true;
  };

  const onClearError = (): void => {
    error = '';
    localError = '';
  };
</script>

<ConfirmPopup
  title="Edit Application Received Date"
  okLabel="Submit"
  {loading}
  onevent={handleEvent}
>
  <Form error={error || localError} onalertclose={onClearError}>
    <div class="input">
      <InputGroup>
        <InputDate
          required={false}
          name="applicationReceivedDate"
          label="Application Received Date"
          value={appReceivedDate}
          oninput={onDateInputChange}
        />
      </InputGroup>
    </div>
  </Form>
</ConfirmPopup>
